import React, { useEffect, useRef, useState } from "react";
import "./nfl-tool-table.css";

export default function ScrollShadow({ children }) {
  const scrollRef = useRef(null);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) {
      return undefined;
    }
    const update = () => setHasMore(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    update();
    el.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    let observer;
    if (window.ResizeObserver) {
      observer = new window.ResizeObserver(update);
      observer.observe(el);
      if (el.firstElementChild) {
        observer.observe(el.firstElementChild);
      }
      const table = el.querySelector("table");
      if (table) {
        observer.observe(table);
      }
    }
    return () => {
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <div className={"nfl-table" + (hasMore ? " has-more" : "")}>
      <div className="nfl-table-scroll" ref={scrollRef}>
        {children}
      </div>
    </div>
  );
}
